import { render, staticRenderFns } from "./SortTree.vue?vue&type=template&id=30721ffb&"
import script from "./SortTree.vue?vue&type=script&lang=js&"
export * from "./SortTree.vue?vue&type=script&lang=js&"
import style0 from "./SortTree.vue?vue&type=style&index=0&id=30721ffb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports